import { render, staticRenderFns } from "./referralTypeSelect.vue?vue&type=template&id=3a130794&scoped=true"
import script from "./referralTypeSelect.vue?vue&type=script&lang=js"
export * from "./referralTypeSelect.vue?vue&type=script&lang=js"
import style0 from "./referralTypeSelect.vue?vue&type=style&index=0&id=3a130794&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a130794",
  null
  
)

export default component.exports